export class Providers {
    private readonly elements: NodeListOf<HTMLElement>;

    constructor(elements: NodeListOf<HTMLElement>) {
        this.elements = elements;
        this.init();
    }

    protected onProviderClick(evt: Event): void {
        evt.preventDefault();

        const
            width = 600,
            height = 400,
            left = (screen.width - width) / 2,
            top = (screen.height - height) / 2,
            item = evt.currentTarget as HTMLElement,
            link = item.querySelector(`a`);

        if (!link) return;
        let url = link.getAttribute(`href`);

        window.open(url,`oauth`, `width=${width},height=${height},left=${left},top=${top},status=no,toolbar=no,menubar=no`);
    }

    protected init(): void {
        if (!this.elements.length) return;
        this.elements.forEach(element => {
            element.addEventListener('click', (evt) => this.onProviderClick(evt));
        })
    }
}